<div class="machine-parameter-content">
    <div class="content-top-box">
      <div class="tab-content-top-box">
        <h1 class="main-title">QA Data Entry</h1>
      </div>
        <form [formGroup]="qaMasterForm" (ngSubmit)="saveMasterEntry()">
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
                <div class="content-top-row">
                    <div class="inputField" style="width: 250px;">
                        <nz-date-picker class="calender-input" style="width: 235px;"
                        formControlName="date" nzFormat="dd/MM/yyyy"
                        [nzInputReadOnly]="true" ></nz-date-picker>
                        <span class="floating-text">Select Date</span>   
                    </div>    
                    <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                        <mat-label>Select Report Type</mat-label>
                        <mat-select formControlName="reportType" panelClass="testClass" name="reportType">
                        <mat-option *ngFor="let rt of reportTypes" [value]="rt.TypeId">{{rt.TypeName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                        <mat-label>Select Crew</mat-label>
                        <mat-select formControlName="crew" panelClass="testClass" name="crew">
                        <mat-option *ngFor="let cl of crewList" [value]="cl.TypeId">{{cl.TypeName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                        <mat-label>Select Shift</mat-label>
                        <mat-select formControlName="shift" panelClass="testClass" name="shift">
                        <mat-option *ngFor="let sl of shiftList" [value]="sl.TypeId">{{sl.TypeName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearence="fill"  class="top-row-first-filed-item top-row-first-filed-item-order-processing" >     
                        <mat-label class="placeholder-title">Enter Quality</mat-label>
                        <input formControlName="quality" class="input-text"  matInput >
                    </mat-form-field>
                </div>
                <div class="content-top-row">
                    <mat-form-field appearence="fill"  style="margin-left: 20px;"
                    class="top-row-first-filed-item top-row-first-filed-item-order-processing" >     
                        <mat-label class="placeholder-title">Enter Standard</mat-label>
                        <input formControlName="standard" class="input-text"  matInput >
                    </mat-form-field>
                    <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                        <mat-label>Select Thickness</mat-label>
                        <mat-select formControlName="thickness" panelClass="testClass" name="shift">
                        <mat-option *ngFor="let ts of thicknessList" [value]="ts.TypeName">{{ts.TypeName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearence="fill"
                    class="top-row-first-filed-item top-row-first-filed-item-order-processing" >     
                        <mat-label class="placeholder-title">Enter Gross Width</mat-label>
                        <input formControlName="grossWidth" class="input-text"  matInput >
                    </mat-form-field>
                    <mat-form-field appearence="fill"
                    class="top-row-first-filed-item top-row-first-filed-item-order-processing" >     
                        <mat-label class="placeholder-title">Enter Net Available</mat-label>
                        <input formControlName="netAvailable" class="input-text"  matInput >
                    </mat-form-field>
                    <mat-form-field appearence="fill"
                    class="top-row-first-filed-item top-row-first-filed-item-order-processing" >     
                        <mat-label class="placeholder-title">Enter Net Cut</mat-label>
                        <input formControlName="netCut" class="input-text"  matInput >
                    </mat-form-field>
                </div>
                <div class="content-top-row">
                    <button type="submit" mat-mini-fab mat-button color="primary" 
                    pTooltip="Save" tooltipPosition="top" 
                    [disabled]="!qaMasterForm.valid"
                    style="margin-left: 10px;">
                        <mat-icon>save</mat-icon>
                    </button>
                    <button type="button" mat-mini-fab mat-button  color="accent"  pTooltip="Add" tooltipPosition="top" style="margin-left: 10px;">
                    <mat-icon>add</mat-icon>
                    </button>
                    <button type="button" mat-mini-fab mat-button  color="primary" 
                    pTooltip="History" (click)="openCommonAttributeHistoryModel()" tooltipPosition="top" style="margin-left: 10px;">
                    <mat-icon>history</mat-icon>
                    </button>
                    <button *ngIf="isLoadingData" type="button" 
                    mat-button mat-flat-button color="accent" 
                    pTooltip="Load" tooltipPosition="top" style="margin-left: 10px;">
                    ↺⟳LOADING...
                    </button>
                    <button *ngIf="!isLoadingData" type="button" (click)="loadReportForm()" 
                    mat-button mat-mini-fab color="warn" 
                    pTooltip="Load" tooltipPosition="top" style="margin-left: 10px;">
                    <mat-icon>sync</mat-icon>
                    </button>
                    <button type="button" mat-button mat-mini-fab color="accent" 
                    (click)="getReports()"
                    pTooltip="Get Report" tooltipPosition="top" style="margin-left: 10px;">
                    <mat-icon>print</mat-icon>
                    </button>
                </div>
            </div>
        </form>
        <div *ngIf="!isReportMode" style="margin-top: 20px;">
          <form *ngIf="formPropertiesArray.length > 0" [formGroup]="qaDynamicForm">
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
              <div class="content-top-row">
                <div class="inputField" style="width: 250px;">
                  <nz-time-picker class="calender-input" style="width: 235px;"
                  formControlName="Time" nzFormat="HH:mm"
                  [nzInputReadOnly]="true" ></nz-time-picker>
                  <span class="floating-text">Select Time</span>   
              </div>  
            </div>
              <div *ngFor="let qaform of formPropertiesArray">
                <h3 style="font-weight: bold;">{{qaform.TypeName}}</h3>
                <div class="content-row-wrap">
                    <mat-form-field *ngFor="let control of qaform.properties" 
                    appearence="fill"
                    style="margin-bottom: 10px;"
                    class="top-row-first-filed-item top-row-first-filed-item-order-processing" >     
                        <mat-label class="placeholder-title">{{control.DisplayName}}</mat-label>
                        <input [formControlName]="control.Name" class="input-text"  matInput >
                    </mat-form-field>
                </div>
              </div>
              <div class="content-top-row">
                <button *ngIf="isMaterialDataMode" type="button" (click)="saveQAData()" mat-mini-fab mat-button color="primary" 
                pTooltip="Save" tooltipPosition="top"
                style="margin-left: 10px;">
                    <mat-icon>save</mat-icon>
                </button>
                <button *ngIf="!isMaterialDataMode" type="button" (click)="updateQAData()" 
                mat-mini-fab mat-button color="warn" 
                pTooltip="Update" tooltipPosition="top"
                style="margin-left: 10px;">
                    <mat-icon>edit</mat-icon>
                </button>
                <button type="button" mat-mini-fab mat-button  color="accent"  pTooltip="Add" tooltipPosition="top" style="margin-left: 10px;">
                <mat-icon>add</mat-icon>
                </button>
                <button type="button" mat-mini-fab mat-button 
                (click)="openMaterialDataHistoryModel()" 
                color="primary" 
                pTooltip="History" tooltipPosition="top" style="margin-left: 10px;">
                <mat-icon>history</mat-icon>
                </button>
              </div>
              <ag-grid-angular
              *ngIf="formPropertiesArray.length > 0"
              style="width: 100%; height: 25vw"
              class="ag-theme-alpine"
              [rowData]="rowData"
              (gridReady)="onGridReady($event)"
              [columnDefs]="columnDefs"
              [gridOptions]="gridOptions"
              [rowSelection]= "rowSelection"
              (cellClicked)="cellClicked($event)"
             [pagination]="true">
              </ag-grid-angular>
            </div>
          </form>
        </div>
        <div *ngIf="isReportMode" style="margin-top: 20px;">
          <div class="wrapper-box wrapper-box-shadow table-wrapper">
            <div class="d-flex justify-content-between items-center">
              <h2 style="font-weight: bold;">Physical - QA Report</h2>
              <h4 style="font-weight: bold;">{{currentDate | date: 'MM/dd/yyy h:mm:ss a'}}</h4>
            </div>
            <div class="d-flex justify-content-between items-center" style="margin: 20px 0 20px 0;">
              <button type="button" 
              mat-button mat-flat-button color="warn" 
              (click)="openPDFExportModel()"
              pTooltip="Load" tooltipPosition="top" style="margin-left: 10px;">
              PDF Print
              </button>
              <button type="button" mat-button mat-flat-button color="accent" 
              (click)="exportToExcel()"
              pTooltip="Get Report" tooltipPosition="top" style="margin-left: 10px;">
               Export To Excel
              </button>
            </div>
            <ag-grid-angular
            style="height: 40vh; width: 100%;"
            class="ag-theme-alpine"
            [rowData]="rowDataReport"
            [columnDefs]="columnDefsReport"
            [gridOptions]="gridOptionsReports"
            (columnEverythingChanged)="onColumnEverythingChanged($event)"
            (firstDataRendered)="onFirstDataRendered($event)"
            (gridReady)="onGridReady($event)"
            [rowSelection]= "rowMultiple"
            >
            </ag-grid-angular>            
          </div>
        </div>
    </div>
</div>


<!--common attribute history modal template-->
<ng-template #displayCommonAttributeHistoryModal>    
    <div class="d-flex justify-content-between align-items-center">
        <h1 mat-dialog-title>Common Attributes</h1>
        <mat-form-field *ngIf="!isLoadingCommonAttribute" appearence="fill"
        class="top-row-first-filed-item top-row-first-filed-item-order-processing">     
            <mat-label class="placeholder-title">Search</mat-label>
            <input class="input-text" matInput (keyup)="applyFilter($event)">
        </mat-form-field>
        <button
          type="button"
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
          (click)="dialog.closeAll()"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
    </div>
    <div *ngIf="isLoadingCommonAttribute" style="display: flex; flex-direction: 
    column; justify-content: center; align-items: center;">
        <img src="assets/images/loading.gif" alt="loading">
        <h1 mat-dialog-title>Loading.....</h1>
    </div>
    <div class="wrapper-box wrapper-box-shadow table-wrapper" *ngIf="commonAttributesData !== undefined">
        <table *ngIf="!isLoadingCommonAttribute" mat-table [dataSource]="commonAttributesData" class="basic-table plant-model-table" matSort>
    
          <ng-container matColumnDef="Id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">ID</p>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.Id}} </td>
          </ng-container>
    
          <ng-container matColumnDef="Shift">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">Shift</p>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.Shift}} </td>
          </ng-container>
          <ng-container matColumnDef="Crew">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">Crew</p>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.Crew}} </td>
          </ng-container>
    
          <ng-container matColumnDef="Quality">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="grp-order">
              <p class="header-text">Quality</p>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.Quality}} </td>
          </ng-container>
          <ng-container matColumnDef="Standard">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">Standard</p>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.Standard}} </td>
          </ng-container>
        <ng-container matColumnDef="Thickness">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
            <p class="header-text">Thickness</p>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Thickness}} </td>
        </ng-container>
        <ng-container matColumnDef="GrossWidth">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="created-By">
            <p class="header-text">Gross Width</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.GrossWidth}}  </td>
        </ng-container>
          <ng-container matColumnDef="NetAvailable">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="created-on">
              <p class="header-text">Net Available</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.NetAvailable}} </td>
          </ng-container>
          <ng-container matColumnDef="NetCut">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="created-on">
              <p class="header-text">Net Cut</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.NetCut}} </td>
          </ng-container>
          <ng-container matColumnDef="CreatedOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="created-on">
              <p class="header-text">Date</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.CreatedOn | date: 'dd-MM-yyyy'}} </td>
          </ng-container>
    
          <!-- plantModelActions Column -->
          <ng-container matColumnDef="Actions" >
            <th mat-header-cell *matHeaderCellDef> <p class="header-text">Actions</p></th>
           
            <td  mat-cell *matCellDef="let element" class="row-action-btns-column">
              <div class="row-action-btns" style="min-width: 78px;">
                <button type="button" mat-icon-button class="edit-btn" 
                (click)="editCommonAttribute(element.Id)"
                aria-label="Edit" 
                pTooltip="Edit" tooltipPosition="top">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                      fill="white" />
                  </svg>
                </button>
                <button type="button" mat-icon-button class="node-control-btn node-delete" 
                aria-label="delete item"
                     pTooltip="Delete" (click)="deleteCommonAttribute(element.Id)" tooltipPosition="top">
                    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" 
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.35547 0.9375H5.60547L5.10547 0.4375H2.60547L2.10547 0.9375H0.355469V1.9375H7.35547V0.9375ZM0.855469 8.4375C0.855469 8.70272 0.960826 8.95707 1.14836 9.14461C1.3359 9.33214 1.59025 9.4375 1.85547 9.4375H5.85547C6.12069 9.4375 6.37504 9.33214 6.56258 9.14461C6.75011 8.95707 6.85547 8.70272 6.85547 8.4375V2.4375H0.855469V8.4375Z"
                        fill="white" />
                    </svg>
                 </button>
              </div>
            </td>
          </ng-container>
    
          <tr mat-header-row *matHeaderRowDef="commonAttributesColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: commonAttributesColumns;"></tr>
        </table>  
        <mat-paginator *ngIf="!isLoadingCommonAttribute" class="basic-paginataor" [pageSizeOptions]="[7, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
</ng-template>


<ng-template #displayMaterialDataHistoryModal>    
    <div class="d-flex justify-content-between align-items-center">
        <h1 mat-dialog-title>Material Data</h1>
        <button
          type="button"
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
          (click)="dialog.closeAll()"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>

      </div>
      <ag-grid-angular
          style="width: 100%; height: 35vw"
          class="ag-theme-alpine"
          [rowData]="rowDataMaterialHistory"
          (gridReady)="onGridReady($event)"
          [columnDefs]="columnDefsMaterialHistory"
          [gridOptions]="gridOptionsDataHistory"
          [rowSelection]= "rowSelection"
          (cellClicked)="cellClickedMaterialHistory($event)"
         [pagination]="true">
      </ag-grid-angular>
</ng-template>
<ng-template #displayPDFExportModal>    
    <div class="d-flex justify-content-between align-items-center">
        <h1 mat-dialog-title>Print Physical QA Report To PDF </h1>
        <button
          type="button"
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
          (click)="dialog.closeAll()"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
      <app-pdf-export-panel
      [agGridApi]="gridApi"
      [agColumnApi]="gridColumnApi"
    ></app-pdf-export-panel>
      
</ng-template>


